import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from "lodash";
import Select from 'react-select';

import axios from 'axios';
import Multiselect from 'multiselect-dropdown-react';
import Breadcrumb from '../common/breadcrumb.component';
import {Redirect} from 'react-router-dom';
import $ from 'jquery';
import SweetAlert from 'react-bootstrap-sweetalert';
var redirectURL = require('../redirectURL');
var googleAnalytics = require("../common/googleanalytics");

var drawingManager;
var selectedShape;
var colors = ['#1D9567', '#1692A5', '#F4D749','#F73E3E', '#B7B3B3' ];
var selectedColor;
var colorButtons = {};
var fencingLength=0;
var mapZoom=12;
var coordinates=[];
const fenchtypeoptions = [
	  { value: 'Plant', label: 'Plant' },
	  { value: 'TVP', label: 'TVP' },
	  { value: 'Stockyard', label: 'Stockyard' },
	  { value: 'Railyard', label: 'Railyard' },
	  { value: 'Port', label: 'Port' },
	  { value: 'Vendor', label: 'Vendor' },
	  { value: 'MSP', label: 'MSP' },
	];


export default class AddAccidentalProneZone extends Component {

    constructor(props) {
        super(props);

        this.state = {
			pageTitle: "Add Accidental Prone Zone",
			eventGridAction: "gridAction",
			eventCounterAction: "counterAction",
			eventFormAction: "formAction",
			currentDepartmentCode: null,
			currentDepartmentTitle: null,
        	routemap:'',
        	departments:[],
        	coords:[],
        	geo_name:'',
        	geo_type:'',
        	fence_type:'',
        	dept_code:[],
        	notify:'',
			erroMessage:'',
			redirectpage:'',
			latitude: '',
			longitude: '',
			basicTitle: "",
			basicType: "",
			show: false
        };
        this.showMap = this.showMap.bind(this);
        this.applyCoords = this.applyCoords.bind(this);
        this.checkHandler = this.checkHandler.bind(this);
        this.checkNotifyHandler = this.checkNotifyHandler.bind(this);
	}
	logPageView = () => {
		try {
			if (googleAnalytics.page.enableGA) {
				googleAnalytics.logPageView();
				let eventGridAction = googleAnalytics.page.actionType.gridAction + " - " + window.location.pathname;
				let eventCounterAction = googleAnalytics.page.actionType.counterAction + " - " + window.location.pathname;
				let eventFormAction = googleAnalytics.page.actionType.formAction + " - " + window.location.pathname;
				this.setState({eventGridAction: eventGridAction, eventCounterAction: eventCounterAction, eventFormAction: eventFormAction});
			} else {
				console.log("GA disabled...");
			}
		} catch(error) {
			console.error("Error occured while logging to GA, error = ", error);
		}
	}
    componentDidMount(){
		if (googleAnalytics.page.enableGA) {
			this.logPageView();
		}

    	
    	this.showMap();
    }
   
    showMap =() =>{
    	this.renderMap();
    }
    renderMap = () => {
    	
           loadScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyBQUmk7hdajZEAYllxKhVPnUx5pXuK-j_Y&libraries=places,drawing&callback=initMap");
           window.initMap = this.initMap
	}
    
       
    initMap = () => {
    	var coordsvalues;
		
    	var map = new window.google.maps.Map(document.getElementById('map_canvas'), {
            zoom: 12,
            center: new window.google.maps.LatLng(17.3580,78.4869),
            mapTypeId: window.google.maps.MapTypeId.ROADMAP,
            mapTypeControl: true,
            mapTypeControlOptions: {
                style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                position: window.google.maps.ControlPosition.TOP_RIGHT
              },            
            disableDefaultUI: true,
            zoomControl: true
          });
		  		

		var marker;

		function placeMarker(location) {
		if ( marker ) {
		console.log("marker", marker)
		marker.setPosition(location);
		} else {
		marker = new window.google.maps.Marker({
		position: location,
		map: map
		});
		// console.log("elsemarker", marker)
		}
		}
		window.google.maps.event.addListener(map, 'click', function(event) {
			console.log(typeof(event.latLng));
			placeMarker(event.latLng);
			console.log("event.latlng:",(event.latLng));		
			let latitude = event.latLng.lat();	
			let longitude = event.latLng.lng();
			document.getElementById('formLatitude').value = latitude;
			document.getElementById('formLongitude').value =  longitude;
		});

		
  		//added by nanda for places dropdown...
  	    var input = document.getElementById('search');
          var searchBox = new window.google.maps.places.SearchBox(input);
          map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(input);

          // Bias the SearchBox results towards current map's viewport.
          map.addListener('bounds_changed', function() {
            searchBox.setBounds(map.getBounds());
          });	
  		
  		var markers = [];
  		console.log("searchBox",searchBox);
  		 searchBox.addListener('places_changed', function() {
            var places = searchBox.getPlaces();

            if (places.length == 0) {
              return;
            }

            // Clear out the old markers.
            markers.forEach(function(marker) {
              marker.setMap(null);
            });
            markers = [];
  			// For each place, get the icon, name and location.
            var bounds = new window.google.maps.LatLngBounds();
            places.forEach(function(place) {
              if (!place.geometry) {
                console.log("Returned place contains no geometry");
                return;
              }
              var icon = {
                url: place.icon,
                size: new window.google.maps.Size(71, 71),
                origin: new window.google.maps.Point(0, 0),
                anchor: new window.google.maps.Point(17, 34),
                scaledSize: new window.google.maps.Size(25, 25)
              };

              // Create a marker for each place.
              markers.push(new window.google.maps.Marker({
                map: map,
                icon: icon,
                title: place.name,
                position: place.geometry.location
              }));

              if (place.geometry.viewport) {
                // Only geocodes have viewport.
                bounds.union(place.geometry.viewport);
              } else {
                bounds.extend(place.geometry.location);
              }
            });
            map.fitBounds(bounds);
          });		
  		//End of adding by nanda
  		
  		// var polyOptions = {
        //     strokeWeight: 0,
        //     fillOpacity: 0.70,
        //     editable: true
        //   };
        //   // Creates a drawing manager attached to the map that allows the user to draw
        //   // markers, lines, and shapes.
        //   drawingManager = new window.google.maps.drawing.DrawingManager({
        //     drawingMode: window.google.maps.drawing.OverlayType.POLYGON,
        //     drawingControlOptions: {
        //       drawingModes: [
        //         window.google.maps.drawing.OverlayType.POLYGON
        //       ]
        //     },
        //     markerOptions: {
        //       draggable: true
        //     },
        //     polylineOptions: {
        //       editable: true
        //     },
        //     rectangleOptions: polyOptions,
        //     circleOptions: polyOptions,
        //     polygonOptions: polyOptions,
        //     map: map
        //   });

        //   window.google.maps.event.addListener(drawingManager, 'overlaycomplete', function(e) {
        //       if (e.type != window.google.maps.drawing.OverlayType.MARKER) {
        //       // Switch back to non-drawing mode after drawing a shape.
        //       drawingManager.setDrawingMode(null);
        //       // To hide:
        //       drawingManager.setOptions({
        //         drawingControl: false
        //       });

        //       // Add an event listener that selects the newly-drawn shape when the user
        //       // mouses down on it.
        //       var newShape = e.overlay;
        //       newShape.type = e.type;
        //       window.google.maps.event.addListener(newShape, 'click', function() {
        //         setSelection(newShape);
        //       });
        //       setSelection(newShape);
        //       //console.log("selectedShape",newShape);
  		// 	  fencingLength = selectedShape.getPath().getLength();
  			  
  		// 		var latlngObj=[];
	  	// 		var htmlStr = "";
	  	//         for (var i = 0; i < fencingLength; i++) {
	  	// 			var each_lat_lng = selectedShape.getPath().getAt(i).toUrlValue(5).split(',');
	  	// 			var in_latlng_array={"lat":parseFloat(each_lat_lng[0]),"lng":parseFloat(each_lat_lng[1])};
	  	// 			latlngObj.push(in_latlng_array);
	  	// 			coordinates.push(in_latlng_array);
	  	// 		}
	  			
        //     }
              
        //   });
          
          
        //   // Clear the current selection when the drawing mode is changed, or when the
        //   // map is clicked.
  		// window.google.maps.event.addListener(drawingManager, 'drawingmode_changed', function(){
  		// 	clearSelection()
  		// });
  		// window.google.maps.event.addListener(map, 'click', function(){
  		// 	clearSelection()
  		// });
        // /*
        //  * window.google.maps.event.addDomListener(document.getElementById('delete-button'), 'click', function(){
        // 		deleteSelectedShape()
		// });
        // */
        
  		
      //buildColorPalette();
  		map.addListener('zoom_changed', function() {
            mapZoom=map.getZoom();
          });
  		
  		/*window.google.maps.event.addDomListener(document.getElementById('saveGeo'), 'click', function(){
  			getSelectedShape()
  		});*/
  		
  		console.log("coordinates", coordinates);
  		
    }
    
    
    
    fenceTypeHandler = (event) => {
    	console.log(event.target)
    }


    changeHandler = geo_type => {

    	this.setState(
	      { geo_type },
	      () => console.log(`Option selected:`, this.state.geo_type)
	    );
	}
    checkHandler = (event) => {
    	
    	let name = event.target.name;
		let value = event.target.value;
    	this.setState({[name]:value});
    }
    changeInputHandler = (event) => {
    	let name = event.target.name;
		let value = event.target.value;
    	this.setState({[name]:value});
		if(name == "latitude" || name == "longitude"){
			console.log(name,value)
			let lat = document.getElementById('formLatitude').value;
			let lng = document.getElementById('formLongitude').value;
			if (lat !== "" && lng !== ""){
				
				var coordsvalues;
		
				var location = new window.google.maps.LatLng(lat,lng);
				var map = new window.google.maps.Map(document.getElementById('map_canvas'), {
					zoom: 12,
					center: location,
					mapTypeId: window.google.maps.MapTypeId.ROADMAP,
					mapTypeControl: true,
					mapTypeControlOptions: {
						style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
						position: window.google.maps.ControlPosition.TOP_RIGHT
					},            
					disableDefaultUI: true,
					zoomControl: true
				});
						

				var marker;
				console.log("location", location)
				marker = new window.google.maps.Marker({
					position: location,
					map: map
				});	

				window.google.maps.event.addListener(map, 'click', function(event) {
					console.log(typeof(event.latLng));
					console.log("event.latlng:",(event.latLng));
					marker.setMap(null);
					marker = new window.google.maps.Marker({
						position: event.latLng,
						map: map
					});	
					let latitude = event.latLng.lat();	
					let longitude = event.latLng.lng();
					document.getElementById('formLatitude').value = latitude;
					document.getElementById('formLongitude').value =  longitude;
					
				});
				//searchbox
				var input = document.getElementById('search');
				var searchBox = new window.google.maps.places.SearchBox(input);
				map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(input);

				// Bias the SearchBox results towards current map's viewport.
				map.addListener("bounds_changed", () => {
					searchBox.setBounds(map.getBounds());
				});
				
				var markers = [];
				console.log("searchBox1",searchBox);
				searchBox.addListener('places_changed', function() {
					var places = searchBox.getPlaces();
					
					if (places.length == 0) {
					return;
					}

					// Clear out the old markers.
					markers.forEach(function(marker) {
					marker.setMap(null);
					});
					markers = [];
					// For each place, get the icon, name and location.
					var bounds = new window.google.maps.LatLngBounds();
					places.forEach(function(place) {
					if (!place.geometry) {
						console.log("Returned place contains no geometry");
						return;
					}
					var icon = {
						url: place.icon,
						size: new window.google.maps.Size(71, 71),
						origin: new window.google.maps.Point(0, 0),
						anchor: new window.google.maps.Point(17, 34),
						scaledSize: new window.google.maps.Size(25, 25)
					};

					// Create a marker for each place.
					markers.push(new window.google.maps.Marker({
						map: map,
						icon: icon,
						title: place.name,
						position: place.geometry.location
					}));

					if (place.geometry.viewport) {
						// Only geocodes have viewport.
						bounds.union(place.geometry.viewport);
					} else {
						bounds.extend(place.geometry.location);
					 }
					});
					 map.fitBounds(bounds);
          		});		
			}
			
				
		}		
    }
    
    changeArrayHandler = dept_code => {
    	/*this.setState({
    		dept_code:[...this.state.dept_code,event.target.value]
    	},() => {
    		console.log(this.state.dept_code)
    	});
    	*/
    	
    	this.setState(
	      { dept_code },
	      () => console.log(`Option selected:`, this.state.dept_code)
	    );
    	
    	
    }
    
    checkNotifyHandler = (event) => {
    	let name = event.target.name;
		let value = event.target.value;
    	this.setState({[name]:value});
    }
    
    applyCoords =(e) =>{
    	console.log(e);
    }
    
	formHandler = (event) => {
			
		event.preventDefault();
		if (googleAnalytics.page.enableGA) {
			let pageTitle = this.state.pageTitle;
			let eventOptions = {
				"category": pageTitle,
				"action": this.state.eventFormAction,
				"label": googleAnalytics.page.action.formSubmitted,
			}
			googleAnalytics.logEvent(eventOptions);
		}
		var formdata1 = new FormData(event.target);
		console.log(coordinates.length);
		// var fRad;
		// var flat;
		// var flong;
		// var frep;
		// var faler;
		// var flang;
		let rowId;
		let formData = {
			rowId: rowId,
            radius : document.getElementById("formRadius").value,
            latitude :document.getElementById("formLatitude").value,
            longitude:document.getElementById("formLongitude").value,
            repeat_count: document.getElementById("formRepeatCount").value,
            alert_type : document.getElementById("formAlertType").value,
			language: document.getElementById("formLanguage").value,
			location_name: document.getElementById("location_name").value,
        }
        
		if(formData.radius !== "" && formData.language !=="" && formData.latitude  !== "" && formData.longitude !== "" && formData.repeat_count !== ""  && formData.alert_type  !== ""  && formData.location_name  !== "")
		{			
			console.log("formData:",formData);
				
			redirectURL.post("/consignments/saveAccidentalProneZones", formData,{
				headers:{
					'Content-Type': 'application/json'
				}
			})
			.then(
				(response)=>{
					console.log(response);
					if(response.data.message == "success")
					{
						this.setState({
							basicTitle:"Updated Successfully.",
							basicType : "success",
							show : true
						})
						window.location.href="/accidentalpronezones";;
					}
					else
					{
						this.setState({
							basicTitle:"Failed to update.",
							basicType : "warning",
							show : true
						})
					}
					//window.location.href='/manage/geofences';
				}
			)
			.catch(function(error){
				console.log(error);
			});
		}
		else
		{
			this.setState({
				erroMessage:'All Fields Are Mandatory'
			});
		}
		
	}
	closeAlert = () => {
		this.setState({
			show: false
		});
	}
    render(){
		if(this.state.redirectpage == 'yes')
		{
			if(this.props.match.path == "/manage/mllsndaddgeofence")
			{
				return <Redirect to={'/manage/mllsndgeofences'} push={true} />
			}
			else
			{
				return <Redirect to={'/manage/geofences'} push={true} />
			}
			
		}
		if(this.props.match.path == "/manage/mllsndaddgeofence")
		{
			var redurl = "/manage/mllsndgeofences";
		}
		else
		{
			var redurl = "/manage/geofences";
		}
    	let order_cnt=[];

    	const dStyles={
				width:'100%',
				height:'500px'
		}
    	 const { dept_code } = this.state;
    	 const { geo_type } = this.state;
        
        return (
            <div className="container-fluid">
            	<div className="row">
            		<div className="col-xl-12 col-lg-12">
					<SweetAlert
						show={this.state.show}
						type={this.state.basicType}
						title={this.state.basicTitle}
						onConfirm={this.closeAlert}
					>
					</SweetAlert>
		            	<div className="card">
		            	
			                <div className="card-header d-flex justify-content-between">
				       			<h5>
				       				<i className="icon-map cus-i"></i> <span>{this.state.pageTitle}</span>
				       			</h5>
								
								<a href="/accidentalProneZones" className="float-right"><button className="btn btn-warning">Back</button></a>
				   			</div>
				   			<div className="row card-body">
				   			
							<form className=" theme-form col-xl-4 col-lg-4" onSubmit={this.formHandler}>
	                    			<div className="col-xl-12 col-lg-12">
										<div className="form-group">
										<label className="c-lbl">Alert Type</label>
											   <select name="view_type" id="formAlertType" className="form-control" required >
                                                    <option value="">Select</option>
                                                    <option value="50">Accident Prone Area Alert</option>
                                                    <option value="51">Low Hanging High Voltage Alert</option>							
                                               </select>         			
					               	   </div>
										<div className="form-group">							               			
										<label className="c-lbl">Select Language</label>
											   <select name="request_type" id="formLanguage" className="form-control" required >
                                                    <option value="">Select</option>
                                                    <option value="1">English</option>
                                                    <option value="2">Hindi</option>													
                                                    <option value="3">Both</option>													
                                               </select>	           		
					               			
					               	   </div>
										  <div className="form-group">
										 	 <label className="c-lbl">Radius (in Meters):</label>
					               			<input type="text" name="radius" id="formRadius" value={this.state.radius} onChange={this.changeInputHandler.bind(this)} className="form-control num-cls" placeholder="Radius" required />

										  </div>
										  <div className="form-group">
										  <label className="c-lbl">Repeat Count</label>
					               			<input type="text" name="repeatCount" id="formRepeatCount" value={this.state.repeatCount} onChange={this.changeInputHandler.bind(this)} className="form-control num-cls" placeholder="Repeat Count" required />

										  </div>
										  <div className="form-group">
										  <label className="c-lbl">Location Name</label>
					               			<input type="text" name="location_name" id="location_name" value={this.state.location_name} onChange={this.changeInputHandler.bind(this)} className="form-control" placeholder="Location Name" required />

										  </div>
										  <div className="form-group">
										  <label className="c-lbl">Latitude</label>
					               			<input type="number" step="any" name="latitude" id="formLatitude" value={this.state.latitude} onChange={this.changeInputHandler.bind(this)} className="form-control" placeholder="Latitude" required />

										  </div>
										  <div className="form-group">
											<label className="c-lbl">Longitude</label>
											<input type="number" step="any" name="longitude" id="formLongitude" value={this.state.longitude} onChange={this.changeInputHandler.bind(this)} className="form-control" placeholder="Longitude" required />
										  </div>
										  <div className="form-group">
											<button type="submit" style={{marginTop:"35px"}} className={"btn btn-success "}>Submit</button>
										  </div>
					               		     
					           		</div>
										
									
				           		</form>
				           		<div className="col-xl-8 col-lg-8">
									{/*
									{this.state.erroMessage == '' ? '':
											<div className="alert alert-danger"></div>
									} */}
									  <input type="text" name="search" className="col-xl-6 col-lg-6 form-control mt-10p ml-10p" id="search" placeholder="Enter Address to search" />
				
				
				               		<div id="map_canvas" className="col-xl-12 col-lg-12" style={dStyles}></div>
				
				 	               <div className="col-xl-12 col-lg-12">
				 					  <input type="hidden" name="coords" id="coords" value={this.state.coords} />
				 				   </div>
				               		
			               		</div>
			           		</div>
		           		</div>
	           		</div>
                </div>
            </div>
                
        );
    }
}
function loadScript(url){
    var index  =window.document.getElementsByTagName("script")[0]
    var script = window.document.createElement("script")
    script.src=url
    script.async=true
    script.defer = true
    index.parentNode.insertBefore(script,index)
}
                   
function timeConvert(n) {
	var num = n;
	var hours = (num / (3600));
	var rhours = Math.floor(hours);
	var minutes = (n) / (60);
	var rminutes = Math.round(minutes);
	return rhours + " hour(s) and " + rminutes + " minute(s).";
}                              
var currentinfowindow = null;
function getTimeInfo(marker,timedet,coords)
{
	var timeinfo = new window.google.maps.InfoWindow({
          content: "Time at this location: " + timedet
        });

	marker.addListener('click', function() {
		
				if (currentinfowindow != null) {
					currentinfowindow.close();
					currentinfowindow = timeinfo;
					timeinfo.open(marker.get('map'), marker);
				}
				else
				{
					currentinfowindow = timeinfo;
					timeinfo.open(marker.get('map'), marker);
				}
				
        });
}


 function clearSelection() {
	    if (selectedShape) {
	      selectedShape.setEditable(false);
	      selectedShape = null;
	    }
	  }

	 function setSelection(shape) {
	    clearSelection();
	    selectedShape = shape;
	    //console.log("selectedShape",selectedShape);
	    shape.setEditable(true);
	    
	    selectColor(shape.get('fillColor') || shape.get('strokeColor'));
	  }

  function deleteSelectedShape() {
		fencingLength=0;  
	    if (selectedShape) {
	      selectedShape.setMap(null);
	    }
	    // To show:
	     drawingManager.setOptions({
	       drawingControl: true
	     });
	  }

	  
	 function selectColor(color) {
	      selectedColor = color;
	      for (var i = 0; i < colors.length; ++i) {
	        var currColor = colors[i];
	        //console.log(colorButtons[currColor]);
	        //colorButtons[currColor].style.border = currColor == color ? '1px solid #789' : '1px solid #fff';
	      }

	      // Retrieves the current options from the drawing manager and replaces the
	      // stroke or fill color as appropriate.
	      var polylineOptions = drawingManager.get('polylineOptions');
	      polylineOptions.strokeColor = color;
	      drawingManager.set('polylineOptions', polylineOptions);

	      var rectangleOptions = drawingManager.get('rectangleOptions');
	      rectangleOptions.fillColor = color;
	      drawingManager.set('rectangleOptions', rectangleOptions);

	      var circleOptions = drawingManager.get('circleOptions');
	      circleOptions.fillColor = color;
	      drawingManager.set('circleOptions', circleOptions);

	      var polygonOptions = drawingManager.get('polygonOptions');
	      polygonOptions.fillColor = color;
	      drawingManager.set('polygonOptions', polygonOptions);
	    }

	function setSelectedShapeColor(color) {
	      if (selectedShape) {
	        if (selectedShape.type == window.google.maps.drawing.OverlayType.POLYLINE) {
	          selectedShape.set('strokeColor', color);
	        } else {
	          selectedShape.set('fillColor', color);
	        }
	      }
	    }

	  function makeColorButton(color) {
	      var button = document.createElement('span');
	      button.className = 'color-button';
	      button.style.backgroundColor = color;
	      window.google.maps.event.addDomListener(button, 'click', function() {
	        selectColor(color);
	        setSelectedShapeColor(color);
	      });

	      return button;
	    }

	  function buildColorPalette() {
	       var colorPalette = document.getElementById('color-palette');
	       for (var i = 0; i < colors.length; ++i) {
	         var currColor = colors[i];
	         var colorButton = makeColorButton(currColor);
	         colorPalette.appendChild(colorButton);
	         colorButtons[currColor] = colorButton;
	       }
	       selectColor(colors[0]);
	     }  
	  
	 function getSelectedShape(coords){
		var lt=[]
		//console.log("coordsLatlngs ",coords);
		for (let value of Object.values(coords)) {
		  //console.log("Val is ",value); // John, then 30
		  lt.push(value)
		}
		//console.log("Combine ",lt);
		document.getElementById('coords').value=lt;
		//return lt;
	}

	$(document).on("input", ".num-cls", function() {
		this.value = this.value.replace(/\D/g,'');
	});
